import Vue from 'vue';
import store from './../../store';

const success = (id, resolve) => {
  store.dispatch('removeBillProduct', id);
  resolve();
};

const failed = reject => reject();

export default (billId, billProductId) => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/bills/${billId}/products/${billProductId}`)
    .then(() => {
      success(billProductId, resolve);
    })
    .catch(() => {
      failed(reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billProduct/destroy.js